/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useRef } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  Spinner,
  Button,
  Label,
  Tooltip,
  Badge,
  UncontrolledTooltip,
} from "reactstrap";

import Select from "react-select";
import CreatableSelect from "react-select/creatable";

import TextareaAutosize from "react-textarea-autosize";

import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";

import mime from "mime";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";

import schema from "./PredefinedMessageValidation.js";

import {
  getPredefinedMessage,
  createPredefinedMessage,
  editPredefinedMessage,
  resetPredefinedMessage,
  resetPredefinedMessages,
  resetError,
} from "../../store/predefinedmessages/actions";

const NewPredefinedMessage = ({ t }) => {
  let { idPredefinedMessage } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const { register, handleSubmit, setValue, errors } = useForm({
    resolver: yupResolver(schema),
  });

  const {
    dataPredefinedMessageGetSet,
    dataPredefinedMessageEditCreate,
    loadingPredefinedMessage,
    loadingPredefinedMessageEditCreate,
    successPredefinedMessage,
    errorPredefinedMessage,
  } = useSelector((state) => state.PredefinedMessage);

  const [newFields, setNewFields] = useState({});
  const [enableSubmit, setEnableSubmit] = useState(false);

  const [predefinedMessageValues, setPredefinedMessageValues] = useState({
    title: "",
    titleBk: "",

    skills: [],
    skillsBk: [],

    global: false,
    globalBk: false,

    text: "",
    textBk: "",

    categories: [],
    categoriesBk: [],

    activated: true,
    activatedBk: true,

    files: "",
    filesBk: "",
  });

  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [tooltipObj, setTooltipObj] = useState(null);

  //FILE CONSTANTS
  const [fileObj, setFileObj] = useState(null);
  const [fileMsgError, setFileMsgError] = useState(null);
  const [activeThumb, setActiveThumb] = useState(false);
  const [infoFile, setInfoFile] = useState({ name: "", type: "" });
  const [fileInputExist, setFileInputExist] = useState(false);
  const fileInputRef = useRef(null);

  const supportedFiles = {
    file: {
      ext: ["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx"],
      maxSize: 10000,
      metric: "KB",
    },
    image: {
      ext: ["png", "jpeg", "jpg"],
      maxSize: 10000,
      metric: "KB",
    },
    video: {
      ext: ["mp4", "avi", "mov", "wmv", "webm", "ogg"],
      maxSize: 10000,
      metric: "KB",
    },
    audio: {
      ext: ["mp3", "aac", "ogg", "mpga", "wav"],
      maxSize: 10000,
      metric: "KB",
    },
  };

  const showToast = useCallback(
    (type, message) => {
      toastr[type](message);
    },
    [successPredefinedMessage]
  );
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () =>
      successPredefinedMessage &&
      dispatch(resetPredefinedMessage()) &&
      dispatch(resetPredefinedMessages()) &&
      history.push("/predefined-messages"),
  };

  const handleCreateEditPredefinedMessage = () => {
    if (idPredefinedMessage) {
      dispatch(editPredefinedMessage(idPredefinedMessage, newFields));
    } else {
      dispatch(createPredefinedMessage(newFields));
    }
  };

  const newPredefinedMessageSubmit = (newPredefinedMessageValues) => {
    handleCreateEditPredefinedMessage();
  };

  const arrayEquals = (a, b) => {
    return (
      Array.isArray(a) &&
      Array.isArray(b) &&
      a.length === b.length &&
      a.every((val, index) => val === b[index])
    );
  };

  const checkTitle = (values, valuesBk) => {
    if (values === valuesBk) {
      delete newFields.title;
      checkSubmit();
    } else {
      setNewFields({
        ...newFields,
        title: values,
      });
    }
  };

  const checkSkills = (values, valuesBk) => {
    if (values !== null) {
      let aux = [];
      let aux1 = values.map((e) => e.value);
      let aux2 =
        valuesBk !== undefined && valuesBk.length > 0
          ? valuesBk.map((e) => e.value)
          : [];

      if (arrayEquals(aux1, aux2)) {
        delete newFields.skills;
        checkSubmit();
      } else {
        values.map((item) => aux.push(item.value));
        setNewFields({
          ...newFields,
          skills: aux,
          global: false,
        });
      }
    } else {
      let aux1 = [];
      let aux2 = valuesBk !== undefined ? valuesBk.map((e) => e.id) : [];

      if (arrayEquals(aux1, aux2)) {
        delete newFields.skills;
        checkSubmit();
      } else {
        setNewFields({
          ...newFields,
          skills: [],
          global: false,
        });
      }
    }
  };

  const checkCategories = (values, valuesBk) => {
    if (values !== null) {
      let aux = [];
      let aux1 = values.map((e) => e.value);
      let aux2 =
        valuesBk !== undefined && valuesBk.length > 0
          ? valuesBk.map((e) => e.value)
          : [];

      if (arrayEquals(aux1, aux2)) {
        delete newFields.categories;
        checkSubmit();
      } else {
        values.map((item) => aux.push(item.value));
        setNewFields({
          ...newFields,
          categories: aux,
        });
      }
    } else {
      let aux1 = [];
      let aux2 = valuesBk !== undefined ? valuesBk.map((e) => e.id) : [];

      if (arrayEquals(aux1, aux2)) {
        delete newFields.categories;
        checkSubmit();
      } else {
        setNewFields({
          ...newFields,
          categories: [],
        });
      }
    }
  };

  const checkGlobal = (values, valuesBk) => {
    if (values === valuesBk) {
      delete newFields.global;
      checkSubmit();
    } else {
      setNewFields({
        ...newFields,
        skills: [],
        global: values,
      });
    }
  };

  const checkText = (values, valuesBk) => {
    if (values === valuesBk) {
      delete newFields.text;
      checkSubmit();
    } else {
      setNewFields({
        ...newFields,
        text: values,
      });
    }
  };

  const checkActivated = (values, valuesBk) => {
    if (values === valuesBk) {
      delete newFields.activated;
      checkSubmit();
    } else {
      setNewFields({
        ...newFields,
        activated: values,
      });
    }
  };

  const checkFile = (values, valuesBk) => {
    if (JSON.stringify(values) === JSON.stringify(valuesBk)) {
      delete newFields.files;
      checkSubmit();
    } else {
      setNewFields({
        ...newFields,
        files: values,
      });
    }
  };

  const optionsSkills = () => {
    let skills = [];

    if (dataPredefinedMessageGetSet?.data?.form?.skill?.length > 0) {
      dataPredefinedMessageGetSet.data.form.skill.map((skill) =>
        skills.push({
          key: skill.id,
          value: skill.id,
          label: skill.name,
        })
      );
    } else {
      if (loadingPredefinedMessage) {
        skills.push({
          value: "loading",
          label: t("Loading..."),
          isDisabled: true,
        });
      } else {
        skills.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }
    return skills;
  };

  const optionsCategories = () => {
    let categories = [];
    if (dataPredefinedMessageGetSet?.data?.form?.categories?.length > 0) {
      dataPredefinedMessageGetSet.data.form.categories.map((category, key) =>
        categories.push({
          key: category.categories + key,
          value: category.categories,
          label: category.categories,
        })
      );
    } else {
      if (loadingPredefinedMessage) {
        categories.push({
          value: "loading",
          label: t("Loading..."),
          isDisabled: true,
        });
      } else {
        categories.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }
    return categories;
  };

  const checkSubmit = () => {
    if (Object.keys(newFields).length > 0) setEnableSubmit(true);
    else setEnableSubmit(false);
  };

  const getInfoFile = (url) => {
    const matchUrl = url.match(new RegExp("name." + "(.*)" + "sv"));
    const name = matchUrl[1].replace("?", "");
    const ext = name.split(".").pop();
    if (supportedFiles.file.ext.includes(ext)) {
      return { name, type: "file" };
    } else if (supportedFiles.image.ext.includes(ext)) {
      return { name, type: "image" };
    } else if (supportedFiles.video.ext.includes(ext)) {
      return { name, type: "video" };
    } else {
      return { name, type: "audio" };
    }
  };

  const resetFile = () => {
    if (fileInputRef?.current) {
      fileInputRef.current.value = "";
      setFileObj(null);
      checkFile(null, predefinedMessageValues.filesBk);
      setPredefinedMessageValues({
        ...predefinedMessageValues,
        files: {},
      });
      setFileMsgError(null);
      setFileInputExist(false);
      delete newFields.files;
    }
  };

  const deleteFile = () => {
    if (activeThumb) {
      setFileObj(null);
      checkFile(null, predefinedMessageValues.filesBk);
      setPredefinedMessageValues({
        ...predefinedMessageValues,
        files: {},
      });
      setFileMsgError(null);
      setFileInputExist(false);
      delete newFields.files;
    }
    setActiveThumb(false);
  };

  const fileToBase64 = async (file) => {
    const result_base64 = await new Promise((resolve) => {
      const fileReader = new FileReader();
      fileReader.onload = () => resolve(fileReader.result);
      fileReader.readAsDataURL(file);
    });
    return result_base64;
  };

  const handleSendFile = async (file) => {
    if (file) {
      const fileBase64 = await fileToBase64(file);
      const fileName = file?.name;
      const dataSplit = fileBase64.split(",");
      const fileMimeType = file?.type;
      const fileType =
        fileMimeType.split("/")[0] === "application"
          ? "file"
          : fileMimeType.split("/")[0];
      const fileExts = mime?.getExtension(fileMimeType);
      const fileSize = file?.size;

      setFileObj({
        name: fileName,
        mimeType: fileMimeType,
        base64: dataSplit[1],
        formData: file,
        type: fileType,
        exts: fileExts,
        size: fileSize,
      });
      setFileInputExist(true);
    }
  };

  /*****FILE VALIDATE*****/
  const fileValidate = (file) => {
    const type = file?.type;
    const extension = file?.exts;
    const size = file?.size;

    try {
      //Validate FileType
      if (
        type === "image" ||
        type === "file" ||
        type === "audio" ||
        type === "video"
      ) {
        //Validate FileExt
        if (supportedFiles[type]?.ext?.includes(extension)) {
          const maxSizeToBytes =
            supportedFiles[type]?.metric === "KB"
              ? supportedFiles[type]?.maxSize * 1024
              : supportedFiles[type]?.metric === "MB"
              ? supportedFiles[type]?.maxSize * 1024 * 1024
              : supportedFiles[type]?.metric === "GB"
              ? supportedFiles[type]?.maxSize * 1024 * 1024 * 1024
              : supportedFiles[type]?.metric === "TB"
              ? supportedFiles[type]?.maxSize * 1024 * 1024 * 1024 * 1024
              : supportedFiles[type]?.maxSize;
          //Validate FileSize
          if (size < maxSizeToBytes) {
            return { error: false, message: null };
          } else {
            return {
              error: true,
              message: `${t("Add files smaller than")} ${
                supportedFiles[type]?.maxSize
              } ${supportedFiles[type]?.metric}`,
            };
          }
        } else {
          const msgExt = ` ${t("Only")} ${t(type)} ${t(
            "with extension"
          )}: ${supportedFiles[type]?.ext?.join(", ")}`;
          return {
            error: true,
            message: `
            ${t("File extension not valid")}.
            ${supportedFiles[type]?.ext ? msgExt : ""}`,
          };
        }
      } else {
        return {
          error: true,
          message: t("File not valid"),
        };
      }
    } catch (error) {
      return {
        error: true,
        message: error,
      };
    }
  };
  useEffect(() => {
    const objValidate = fileValidate(fileObj);
    const isValidate = !objValidate?.error;
    if (isValidate) {
      const fileResult = {
        data: fileObj?.base64,
        mimeType: fileObj?.mimeType,
        fileName: fileObj?.name,
      };
      setPredefinedMessageValues({
        ...predefinedMessageValues,
        files: fileResult,
      });
      setValue("predefinedMessageFiles", fileResult);
      checkFile(fileResult, predefinedMessageValues?.filesBk);
      setFileInputExist(true);
    }
    setFileMsgError(objValidate?.message);
  }, [fileObj]);

  useEffect(() => {
    if (fileMsgError?.length > 0 && fileInputExist) {
      setEnableSubmit(false);
    }
  }, [fileMsgError, fileInputExist]);

  useEffect(() => {
    setTooltipOpen(true);
    setTimeout(() => {
      setTooltipOpen(false);
    }, 1500);
  }, [tooltipObj]);

  useEffect(() => {
    if (idPredefinedMessage) {
      dispatch(getPredefinedMessage(idPredefinedMessage, true));
    } else {
      dispatch(getPredefinedMessage(null, true));
    }
  }, []);

  useEffect(() => {
    if (
      idPredefinedMessage &&
      dataPredefinedMessageGetSet &&
      dataPredefinedMessageGetSet.data &&
      !loadingPredefinedMessage
    ) {
      setValue(
        "predefinedMessageSkill",
        dataPredefinedMessageGetSet.data.skills
      );
      setValue(
        "predefinedMessageCategories",
        dataPredefinedMessageGetSet.data.categories
      );
      setPredefinedMessageValues({
        ...predefinedMessageValues,
        title: dataPredefinedMessageGetSet.data.title,
        titleBk: dataPredefinedMessageGetSet.data.title,

        skills:
          dataPredefinedMessageGetSet?.data?.skills &&
          dataPredefinedMessageGetSet.data.skills.length > 0
            ? dataPredefinedMessageGetSet.data.skills.map((e) => ({
                key: e.id,
                value: e.id,
                label: e.name,
              }))
            : [],
        skillsBk:
          dataPredefinedMessageGetSet?.data?.skills &&
          dataPredefinedMessageGetSet.data.skills.length > 0
            ? dataPredefinedMessageGetSet.data.skills.map((e) => ({
                key: e.id,
                value: e.id,
                label: e.name,
              }))
            : [],

        global: dataPredefinedMessageGetSet.data.global ? true : false,
        globalBk: dataPredefinedMessageGetSet.data.global ? true : false,

        text: dataPredefinedMessageGetSet.data.text,
        textBk: dataPredefinedMessageGetSet.data.text,

        categories:
          dataPredefinedMessageGetSet?.data?.categories &&
          dataPredefinedMessageGetSet.data.categories.length > 0
            ? dataPredefinedMessageGetSet.data.categories.map((e, key) => ({
                key: e + key,
                value: e,
                label: e,
              }))
            : [],
        categoriesBk:
          dataPredefinedMessageGetSet?.data?.categories &&
          dataPredefinedMessageGetSet.data.categories.length > 0
            ? dataPredefinedMessageGetSet.data.categories.map((e, key) => ({
                key: e + key,
                value: e,
                label: e,
              }))
            : [],
        activated: dataPredefinedMessageGetSet.data.activated ? true : false,
        activatedBk: dataPredefinedMessageGetSet.data.activated ? true : false,

        files: dataPredefinedMessageGetSet?.data?.files,
        filesBk: dataPredefinedMessageGetSet?.data?.files,
      });
    }

    if (dataPredefinedMessageGetSet?.data?.files) {
      setActiveThumb(true);
      setInfoFile(getInfoFile(dataPredefinedMessageGetSet?.data?.files));
    } else {
      setActiveThumb(false);
    }
  }, [dataPredefinedMessageGetSet]);

  useEffect(() => {
    if (
      dataPredefinedMessageEditCreate &&
      dataPredefinedMessageEditCreate.message
    ) {
      showToast("success", t(dataPredefinedMessageEditCreate.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successPredefinedMessage]);

  useEffect(() => {
    if (errorPredefinedMessage && typeof errorPredefinedMessage === "object") {
      errorPredefinedMessage.forEach((error) => {
        if (error) {
          return showToast(
            "error",
            t(
              "Categories length must be less than or equal to 50 characters long"
            )
          );
        }
      });
      dispatch(resetError());
    } else {
      if (errorPredefinedMessage) {
        showToast("error", t(errorPredefinedMessage));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorPredefinedMessage]);

  useEffect(() => {
    checkSubmit();
  }, [newFields]);

  useEffect(() => {}, [predefinedMessageValues]);

  const setClassName = (errors, classname) => {
    return errors ? "av-invalid is-invalid " + classname : classname;
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/predefined-messages"
            path={"/predefined-message"}
            title={t("Predefined Messages")}
            breadcrumbItem={
              idPredefinedMessage
                ? t("Edit Predefined Message")
                : t("Create predefined message")
            }
          />
          <Row>
            <Col xs="12" className="customContent">
              <Card>
                <CardBody>
                  <form onSubmit={handleSubmit(newPredefinedMessageSubmit)}>
                    <Row className="mb-3 justify-content-between">
                      <Col className="pr-2" lg="7">
                        <Row>
                          <Col md="12">
                            <FormGroup>
                              <Label id="predefinedMessage-name-label">
                                {t("Title") + " *"}
                              </Label>
                              <input
                                type="text"
                                name="predefinedMessageName"
                                ref={register}
                                className={setClassName(
                                  errors.predefinedMessageName,
                                  "form-control"
                                )}
                                placeholder={t("Enter predefined message name")}
                                onChange={(e) => {
                                  setPredefinedMessageValues({
                                    ...predefinedMessageValues,
                                    title: e.target.value,
                                  });
                                  checkTitle(
                                    e.target.value,
                                    predefinedMessageValues.titleBk
                                  );
                                }}
                                defaultValue={predefinedMessageValues.title}
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.predefinedMessageName?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup className="select2-container">
                              <div
                                className="d-flex justify-content-between w-100"
                                name="predefinedMessageType"
                              >
                                <Label id="predefinedMessages-skill">
                                  {t("Skills") + " *"}
                                </Label>
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    name="predefinedMessageGlobal"
                                    id="global"
                                    ref={register}
                                    checked={
                                      predefinedMessageValues.global
                                        ? true
                                        : false
                                    }
                                    readOnly
                                  />
                                  <label
                                    id="predefinedMessages-global"
                                    className="custom-control-label"
                                    onClick={() => {
                                      if (!predefinedMessageValues.global) {
                                        setPredefinedMessageValues({
                                          ...predefinedMessageValues,
                                          global:
                                            !predefinedMessageValues.global,
                                          skills: null,
                                        });
                                        delete newFields.skills;
                                        setValue(
                                          "predefinedMessageSkill",
                                          null
                                        );
                                      } else {
                                        setPredefinedMessageValues({
                                          ...predefinedMessageValues,
                                          global:
                                            !predefinedMessageValues.global,
                                        });
                                      }
                                      checkGlobal(
                                        !predefinedMessageValues.global,
                                        predefinedMessageValues.globalBk
                                      );
                                    }}
                                  >
                                    {t("Enable Global")}
                                  </label>
                                </div>
                              </div>
                              <Select
                                id="predefinedMessageskill"
                                name="predefinedMessageSkill"
                                noOptionsMessage={() => t("No Options")}
                                ref={() =>
                                  register({ name: "predefinedMessageSkill" })
                                }
                                classNamePrefix="select2-selection"
                                className={setClassName(
                                  errors.predefinedMessageSkill,
                                  " select2-selection"
                                )}
                                placeholder={t("Choose") + "..."}
                                options={optionsSkills()}
                                onChange={(e) => {
                                  let value = e ? e : [];
                                  setValue("predefinedMessageSkill", value);
                                  if (predefinedMessageValues.global) {
                                    setPredefinedMessageValues({
                                      ...predefinedMessageValues,
                                      skills: value,
                                      global: null,
                                    });
                                  } else {
                                    setPredefinedMessageValues({
                                      ...predefinedMessageValues,
                                      skills: value,
                                    });
                                  }
                                  checkSkills(
                                    value,
                                    predefinedMessageValues.skillsBk
                                  );
                                }}
                                value={predefinedMessageValues.skills}
                                isMulti
                                isClearable
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.predefinedMessageSkill?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup className="select2-container">
                              <div
                                className="d-flex justify-content-between w-100"
                                name="predefinedMessageType"
                              >
                                <Label id="predefinedMessages-skill">
                                  {t("Categories")}
                                </Label>
                              </div>
                              <CreatableSelect
                                id="predefinedMessageCategories"
                                name="predefinedMessageCategories"
                                formatCreateLabel={(value) => (
                                  <span>
                                    {t("Create")} "{value}"
                                  </span>
                                )}
                                noOptionsMessage={() => t("No Options")}
                                ref={() =>
                                  register({
                                    name: "predefinedMessageCategories",
                                  })
                                }
                                classNamePrefix="select2-selection"
                                className={setClassName(
                                  errors.predefinedMessageCategories,
                                  " select2-selection"
                                )}
                                placeholder={t("Choose") + "..."}
                                options={optionsCategories()}
                                onChange={(e) => {
                                  let value = e ? e : [];

                                  setValue(
                                    "predefinedMessageCategories",
                                    value
                                  );
                                  setPredefinedMessageValues({
                                    ...predefinedMessageValues,
                                    categories: value,
                                  });
                                  checkCategories(
                                    value,
                                    predefinedMessageValues.categoriesBk
                                  );
                                }}
                                value={predefinedMessageValues.categories}
                                isMulti
                                isClearable
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.predefinedMessageCategories?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup>
                              <Label id="predefinedMessage-name-label">
                                {t("Text") + " *"}
                              </Label>
                              <div className="textarea-container">
                                <TextareaAutosize
                                  type="textarea"
                                  name="predefinedMessageText"
                                  ref={register}
                                  className={setClassName(
                                    errors.predefinedMessageText,
                                    "form-control"
                                  )}
                                  placeholder={t(
                                    "Enter predefined message text"
                                  )}
                                  onChange={(e) => {
                                    setPredefinedMessageValues({
                                      ...predefinedMessageValues,
                                      text: e.target.value,
                                    });
                                    checkText(
                                      e.target.value,
                                      predefinedMessageValues.textBk
                                    );
                                  }}
                                  defaultValue={predefinedMessageValues.text}
                                />
                                <div id="textCopy"></div>
                              </div>
                              <div className="invalid-feedback d-block">
                                {t(errors.predefinedMessageText?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup>
                              <div className="d-flex justify-content-between">
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    name="predefinedMessageActivated"
                                    id="activated"
                                    ref={register}
                                    checked={
                                      predefinedMessageValues.activated
                                        ? true
                                        : false
                                    }
                                    readOnly
                                  />
                                  <label
                                    id="predefinedMessages-activated"
                                    className="custom-control-label"
                                    onClick={() => {
                                      setPredefinedMessageValues({
                                        ...predefinedMessageValues,
                                        activated:
                                          !predefinedMessageValues.activated,
                                      });
                                      checkActivated(
                                        !predefinedMessageValues.activated,
                                        predefinedMessageValues.activatedBk
                                      );
                                    }}
                                  >
                                    {t("Activated")}
                                  </label>
                                </div>

                                {/* FILE */}
                                {activeThumb ? (
                                  <div className="d-flex align-self-center w-200 overflow-auto">
                                    <div>
                                      <div>
                                        {infoFile?.name || fileObj?.fileName}
                                      </div>

                                      <Button
                                        className="justify-content-center"
                                        color="info"
                                        onClick={(e) => {
                                          window.open(
                                            predefinedMessageValues?.files
                                          );
                                        }}
                                      >
                                        <i
                                          className={`bx ${
                                            infoFile?.type === "file"
                                              ? "bx-file-blank"
                                              : infoFile?.type === "image"
                                              ? "bx-image"
                                              : infoFile?.type === "video"
                                              ? "bx-movie"
                                              : infoFile?.type === "audio"
                                              ? "bx-music"
                                              : "bx-file-blank"
                                          } px-2  `}
                                        />
                                        {t("Preview")}
                                      </Button>

                                      <Button
                                        color="danger"
                                        onClick={() => {
                                          deleteFile();
                                        }}
                                      >
                                        <i
                                          color="white"
                                          className="mdi mdi-window-close pointer"
                                          id="deletetooltip"
                                        >
                                          <UncontrolledTooltip
                                            placement="left"
                                            target="deletetooltip"
                                          >
                                            {t("Delete")}
                                          </UncontrolledTooltip>
                                        </i>
                                      </Button>
                                    </div>
                                  </div>
                                ) : (
                                  <div
                                    className="d-flex"
                                    ref={() =>
                                      register({
                                        name: "predefinedMessageFiles",
                                      })
                                    }
                                  >
                                    <input
                                      id="predefinedMessageFiles"
                                      ref={fileInputRef}
                                      type="file"
                                      onChange={(e) => {
                                        handleSendFile(e?.target?.files[0]);
                                      }}
                                      onClick={(e) => {
                                        resetFile();
                                      }}
                                    />
                                    {fileObj && (
                                      <div className="align-self-center">
                                        <i
                                          onClick={() => {
                                            resetFile();
                                          }}
                                          className="mdi mdi-window-close text-danger pointer"
                                          id="deletetooltip"
                                        >
                                          <UncontrolledTooltip
                                            placement="left"
                                            target="deletetooltip"
                                          >
                                            {t("Delete")}
                                          </UncontrolledTooltip>
                                        </i>
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                              {fileMsgError && fileInputExist && (
                                <div className="d-flex mt-1">
                                  <Badge
                                    color="danger"
                                    className="font-size-13 wrap-normal"
                                  >
                                    {fileMsgError}
                                  </Badge>
                                </div>
                              )}
                            </FormGroup>
                            <div className="invalid-feedback d-block">
                              {t(errors.predefinedMessageFiles?.data.message)}
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col lg="5">
                        <Row>
                          <Col md="12">
                            <Label className="w-100">{t("Keywords")}</Label>
                            <div className="font-size-12 mb-3">
                              <span>
                                {t(
                                  "The keywords below can be used on message to show dynamic data, click below to copy them"
                                )}
                              </span>
                            </div>
                            <div className="keywords-notepad font-size-11">
                              <div className="keywords-notepad item">
                                <ul className="px-3 mb-0">
                                  {dataPredefinedMessageGetSet?.data?.form?.keywords
                                    ?.sort((a, b) => (a.word < b.word ? -1 : 1))
                                    ?.map((item, key) => (
                                      <li
                                        key={key}
                                        className="mb-1 keywords-li"
                                        onClick={() => {
                                          navigator.clipboard.writeText(
                                            item?.word
                                          );
                                          setTooltipObj({
                                            target: `keywords-li-${key}`,
                                            message: `${item?.word} ${t(
                                              "Copied to keyboard!"
                                            )}`,
                                          });
                                        }}
                                      >
                                        <div
                                          id={`keywords-li-${key}`}
                                          className="keywords-li label "
                                        >
                                          {item?.word}
                                        </div>
                                        {" - "}
                                        <span>{item?.messages[0]?.text}</span>
                                        {"  "}
                                        <i className="mdi mdi-content-copy" />
                                      </li>
                                    ))}
                                </ul>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    {tooltipOpen && tooltipObj && (
                      <Tooltip
                        placement="auto"
                        isOpen={tooltipOpen}
                        target={tooltipObj?.target}
                      >
                        <div className="keywords-tooltip">
                          {tooltipObj?.message}
                        </div>
                      </Tooltip>
                    )}

                    <Button
                      type="submit"
                      color="primary"
                      className="mr-1 waves-effect waves-light"
                      style={{
                        minWidth: "100px",
                        cursor: enableSubmit ? "pointer" : "no-drop",
                      }}
                      disabled={!enableSubmit}
                    >
                      {loadingPredefinedMessageEditCreate ? (
                        <Spinner
                          size="sm"
                          animation="border"
                          style={{
                            height: "19px",
                            width: "19px",
                          }}
                        />
                      ) : (
                        t("Confirm")
                      )}
                    </Button>
                    <Link to="/predefined-messages">
                      <Button
                        type="button"
                        color="secondary"
                        className="waves-effect btn-dark"
                        onClick={() => dispatch(resetPredefinedMessage())}
                      >
                        {t("Cancel")}
                      </Button>
                    </Link>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(NewPredefinedMessage);
